import { Student } from '../types';

const PIN_1234_HASH = "05d5d2bc38fc5a64ea03bbea341ad80db3bc480c8b20ef9383045e17a25db89f";
const DEFAULT_SALT = "salt1234";

export const ALL_ENROLLED_STUDENTS: Student[] = [
  // ==========================================
  // Class C1-112 (49 Students)
  // ==========================================
  {
    id: 'STU-C1-001',
    registerNumber: '26009479',
    name: 'AJAY KRISHNAN S',
    email: 'ajaykrish2233@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-002',
    registerNumber: '26018281',
    name: 'ANUSHA S',
    email: 'anusha182009@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-003',
    registerNumber: '26002838',
    name: 'ASHWATH SUDHAN S',
    email: 'senthil.chari1479@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-004',
    registerNumber: '26012232',
    name: 'Akilesh BE',
    email: 'akileshbe2007@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-005',
    registerNumber: '26005640',
    name: 'BAHEEJUDEEN B',
    email: 'baheejudeen.m31@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-006',
    registerNumber: '26014714',
    name: 'Balsam syed S',
    email: 'ballu281008@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-007',
    registerNumber: '26014620',
    name: 'C.Muthu Arunachalam',
    email: 'muthuh5723@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-008',
    registerNumber: '26018157',
    name: 'D Likitha',
    email: 'd.hemant.raju@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-009',
    registerNumber: '26019355',
    name: 'DHANUSHMATHI K',
    email: 'dhanushmathi09@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-010',
    registerNumber: '26019499',
    name: 'DHESINGH B',
    email: 'dhesingh27@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-011',
    registerNumber: '26019361',
    name: 'GUNASEELAN K',
    email: 'gunaseelan.k2801@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-012',
    registerNumber: '26011976',
    name: 'Havithra S',
    email: 'havithrasiva2009@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-013',
    registerNumber: '26004326',
    name: 'J Shyam Sundar',
    email: 'deepajayakumar448@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-014',
    registerNumber: '26010934',
    name: 'JEEVANANDHAM V',
    email: 'jeevaharsh29@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-015',
    registerNumber: '26018039',
    name: 'KESAVAN R',
    email: 'ajiramesh23@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-016',
    registerNumber: '26014878',
    name: 'LOGAESHWARI S',
    email: 'logaeshwari2008@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-017',
    registerNumber: '26017329',
    name: 'M RAMYA',
    email: 'rm0453550@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-018',
    registerNumber: '26018359',
    name: 'M.kokila',
    email: 'kokilamasilamani2009@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-019',
    registerNumber: '26000161',
    name: 'MANOJ N',
    email: 'mnandakumar1978@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-020',
    registerNumber: '26015627',
    name: 'MOHAMED ADHIL A',
    email: 'abdulnavas9191@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-021',
    registerNumber: '26018947',
    name: 'MOHAMED HAFEEL J',
    email: 'mohamedhafeel012009@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-022',
    registerNumber: '26016688',
    name: 'MOHAMMED AFZAL KHAN M',
    email: 'afzalrafi2009@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-023',
    registerNumber: '26012045',
    name: 'NANDHAKUMAR S',
    email: 'nandha292009@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-024',
    registerNumber: '26018345',
    name: 'NITHISH S',
    email: 'n2380794@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-025',
    registerNumber: '26019334',
    name: 'PRASSHANTH T',
    email: 'prasshanth8b@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-026',
    registerNumber: '26001904',
    name: 'Priyadharshini S',
    email: 'dharshinipriya4324@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-027',
    registerNumber: '26013038',
    name: 'Rubith J S',
    email: 'rubithjs@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-028',
    registerNumber: '26019106',
    name: 'SAHANA R',
    email: 'sahanarajendiran33@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-029',
    registerNumber: '26019260',
    name: 'SAI SANTHOSH S',
    email: 'saisandy.2k3009@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-030',
    registerNumber: '26019257',
    name: 'SANJAI KUMAR P',
    email: 'sanjaisanjaisanjai997@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-031',
    registerNumber: '26018288',
    name: 'SANKARI M',
    email: 'msankari757@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-032',
    registerNumber: '26012358',
    name: 'SANTHOSH P',
    email: 'santhoshkumar4642008@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-033',
    registerNumber: '26010905',
    name: 'SENTHURAN S .',
    email: 'senthuransembian8411@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-034',
    registerNumber: '26003336',
    name: 'SHIFA M',
    email: 'hmdjaffersadat@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-035',
    registerNumber: '26004623',
    name: 'SHYAAM S',
    email: 'goditachi932@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-036',
    registerNumber: '26017254',
    name: 'SINDHUJA S',
    email: 's.sindhuja2026@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-037',
    registerNumber: '26015572',
    name: 'SUDHIR NADAR',
    email: 'jeyam123@yahoo.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-038',
    registerNumber: '26018167',
    name: 'SUMAN M',
    email: 'msuman15102008@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-039',
    registerNumber: '26018334',
    name: 'SUPRIYA R',
    email: 'supriyarajendiran56@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-040',
    registerNumber: '26019095',
    name: 'Saiprasath D',
    email: 'saiprasanth634@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-041',
    registerNumber: '26018943',
    name: 'Santhosh.A',
    email: 'asanthosh0465@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-042',
    registerNumber: '26005061',
    name: 'Santosh Kumaran S',
    email: 'ssantoshkumaran@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-043',
    registerNumber: '26004655',
    name: 'Sarjun ahamed M',
    email: 'mubarakrazeen@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-044',
    registerNumber: '26010549',
    name: 'Suryanarayan G Menon',
    email: 'suryanarayangmenon12@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-045',
    registerNumber: '26016843',
    name: 'Sushanth Krishna ER',
    email: 'sushanthkrishnaer@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-046',
    registerNumber: '26015012',
    name: 'TARUN K',
    email: 'sktarun2511@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-047',
    registerNumber: '26003316',
    name: 'THILACK R',
    email: 'thilackthilackrajendran@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-048',
    registerNumber: '26014344',
    name: 'VIGNESHWAR E',
    email: 'aemurthy@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C1-049',
    registerNumber: '26006280',
    name: 'sojan s',
    email: 'rohithgrace@gmail.com',
    classId: 'C1-112',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },

  // ==========================================
  // Class C2-147 (55 Students)
  // ==========================================
  {
    id: 'STU-C2-001',
    registerNumber: '26016734',
    name: 'ADITYA N',
    email: 'cadityan6@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-002',
    registerNumber: '26008892',
    name: 'Anli Jovita C',
    email: 'sjagency2008@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-003',
    registerNumber: '26018983',
    name: 'BHARATH D',
    email: 'vpdbharath2008@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-004',
    registerNumber: '26018910',
    name: 'DAYANITHI LOKESH L',
    email: 'dayanithilokesh77@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-005',
    registerNumber: '26002500',
    name: 'DHARSHAN E',
    email: 'elumalaiv2282@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-006',
    registerNumber: '26019086',
    name: 'DHIYA S',
    email: 'dhiya.sbydr@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-007',
    registerNumber: '26019118',
    name: 'DILAN R',
    email: 'rdilandk123@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-008',
    registerNumber: '26000741',
    name: 'DINESH KUMAR S',
    email: 'sdinesh.kumar2611@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-009',
    registerNumber: '26008199',
    name: 'Gowtham Rishi D',
    email: 'gowthamrishi2012@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-010',
    registerNumber: '26019069',
    name: 'HANNAH VASANTHI A',
    email: 'sambuilders@yahoo.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-011',
    registerNumber: '26005666',
    name: 'HEMAVARSHA. T.K',
    email: 'hemavarsha134@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-012',
    registerNumber: '26013195',
    name: 'JEEVADHIVYAA M',
    email: 'venamano89@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-013',
    registerNumber: '26018311',
    name: 'JOTHESWARA M',
    email: 'jotheswara29122008@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-014',
    registerNumber: '26007383',
    name: 'K Heeravardhini',
    email: 'rohithdhoni18@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-015',
    registerNumber: '26015458',
    name: 'KAVIN M',
    email: 'kavin04128@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-016',
    registerNumber: '26018913',
    name: 'KIRUTHIKA D',
    email: 'kiruthika02009@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-017',
    registerNumber: '26011011',
    name: 'Keerthana V',
    email: 'keerthanav835@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-018',
    registerNumber: '26007271',
    name: 'Khenza fathima. B',
    email: 'khenzabasheer@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-019',
    registerNumber: '26019050',
    name: 'LAKSHIKA S',
    email: 's.lakshika1809@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-020',
    registerNumber: '26018671',
    name: 'LOGAVANI D',
    email: 'logavani710@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-021',
    registerNumber: '26019507',
    name: 'LOGESH S',
    email: 'logesh27042009@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-022',
    registerNumber: '26012382',
    name: 'Lingeshwar S',
    email: 'lingeshwar450@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-023',
    registerNumber: '26017320',
    name: 'M Gogulasharvathan',
    email: 'gogulasharvathan@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-024',
    registerNumber: '26018131',
    name: 'M.K. Akshara',
    email: 'mkaksharaa2009@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-025',
    registerNumber: '26018230',
    name: 'MOHAMED IRBAN A',
    email: 'irfan30112007@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-026',
    registerNumber: '26019348',
    name: 'MONISH D',
    email: 'monishmonish70686@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-027',
    registerNumber: '26016732',
    name: 'Mohanakrishna S',
    email: 'm25196818@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-028',
    registerNumber: '26004164',
    name: 'Monish Kumar V',
    email: 'monishkumar24108@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-029',
    registerNumber: '26009381',
    name: 'NARESH S',
    email: 'naresh10082008@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-030',
    registerNumber: '26018962',
    name: 'NARMATHA S',
    email: 'nalinaida2009@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-031',
    registerNumber: '26015028',
    name: 'NITHISH R',
    email: 'nithishrupika18@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-032',
    registerNumber: '26015712',
    name: 'NITHISH S',
    email: 'nithish7281@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-033',
    registerNumber: '26006727',
    name: 'P. YESHWANTH',
    email: 'sarusarathi70@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-034',
    registerNumber: '26018169',
    name: 'PRABHU D',
    email: 'prabhuprabhud185@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-035',
    registerNumber: '26017227',
    name: 'PRAGALYA SRI T',
    email: 'thiyagarajankumar@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-036',
    registerNumber: '26018985',
    name: 'PRAVEEN RAJ F',
    email: 'praveenraj05112008@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-037',
    registerNumber: '26016460',
    name: 'Prathiksha B',
    email: 'b.krishnavenikonar@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-038',
    registerNumber: '26018361',
    name: 'Priyadharshini D',
    email: 'dpriyadharshinidurairaj2008@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-039',
    registerNumber: '26016508',
    name: 'RAMANEESHWARI.S',
    email: 'ramaneeshwarisampath@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-040',
    registerNumber: '26010157',
    name: 'RISMIYA FARWIN.S',
    email: 'syedsathikali1901@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-041',
    registerNumber: '26019283',
    name: 'ROSUN B',
    email: 'rosun4207@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-042',
    registerNumber: '26002627',
    name: 'S S Vikranth',
    email: 'vikranthpillai.39@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-043',
    registerNumber: '26014119',
    name: 'S.Sameer',
    email: 'sameersameerofficial545@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-044',
    registerNumber: '26017972',
    name: 'SHANMUGA SHREE G',
    email: 'harinishree2812@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-045',
    registerNumber: '26011541',
    name: 'SUDAROLI RAJAN S K',
    email: 'sudarolikumar@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-046',
    registerNumber: '26009931',
    name: 'Saai Kathir P L',
    email: 'saaikathir94@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-047',
    registerNumber: '26009858',
    name: 'Sandhiya M',
    email: 'sandhiyamuragan@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-048',
    registerNumber: '26000969',
    name: 'Selvan Mano',
    email: 'senchals.senthil@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-049',
    registerNumber: '26009610',
    name: 'Stephy Paul G',
    email: 'paulstephy09@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-050',
    registerNumber: '26019133',
    name: 'Subiksha M N',
    email: 'nagarajani1972@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-051',
    registerNumber: '26016264',
    name: 'TAMILSELVI S',
    email: 'tamilselvisss008@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-052',
    registerNumber: '26016280',
    name: 'THARUN R',
    email: 'sangeethasangeetharam381@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-053',
    registerNumber: '26018199',
    name: 'THEERTHA R S',
    email: 'theerthars784@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-054',
    registerNumber: '26002245',
    name: 'YAASHITHA P',
    email: 'yaashuyaashitha4266@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C2-055',
    registerNumber: '26018406',
    name: 'YUVASRI J',
    email: 'yuvasriyuva2008@gmail.com',
    classId: 'C2-147',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },

  // ==========================================
  // Class C3-091 (50 Students)
  // ==========================================
  {
    id: 'STU-C3-001',
    registerNumber: '26018966',
    name: 'ABIMANYU R',
    email: 'aravinth8384@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-002',
    registerNumber: '26004779',
    name: 'ABITHA E',
    email: 'abithae0275@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-003',
    registerNumber: '26009908',
    name: 'ASVITHA R',
    email: 'asvitharavi21@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-004',
    registerNumber: '26001831',
    name: 'B. Leiha Varsha',
    email: 'leihavarsha@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-005',
    registerNumber: '26018731',
    name: 'BAIRAVASUNDARAM A',
    email: 'tprcomputers@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-006',
    registerNumber: '26013351',
    name: 'BALAKRISHNAN G',
    email: 'govindarajshetty1777@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-007',
    registerNumber: '26018906',
    name: 'BENSON IMMANUEL R',
    email: 'bensonmaster076@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-008',
    registerNumber: '26001389',
    name: 'DARSHAN R',
    email: 'mrdarshan489@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-009',
    registerNumber: '26009307',
    name: 'GRESIGA R S',
    email: 'gresiga229@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-010',
    registerNumber: '26009013',
    name: 'HARIHARAN.T',
    email: 'ohmhariohmhari2021@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-011',
    registerNumber: '26018137',
    name: 'HARISH S',
    email: 'harish244524@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-012',
    registerNumber: '26016351',
    name: 'HEMPRAKASH.S',
    email: 'hemprakash1525@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-013',
    registerNumber: '26009332',
    name: 'Harini M',
    email: 'h15306925@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-014',
    registerNumber: '26009876',
    name: 'Harshitha Thulsi Raman',
    email: 'harshitha.thulasiraman@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-015',
    registerNumber: '26019063',
    name: 'Hemanath S',
    email: 'shemanath2009@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-016',
    registerNumber: '26017472',
    name: 'JASRA.J',
    email: 'jasrajunaitha@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-017',
    registerNumber: '26018231',
    name: 'JAYALAKSHMI P',
    email: 'jayapalani2009@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-018',
    registerNumber: '26019416',
    name: 'JEEVAN M',
    email: 'jeevanmadhavan1206@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-019',
    registerNumber: '26009503',
    name: 'JERSHILIN MAHIBA J',
    email: 'vensjack7@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-020',
    registerNumber: '26010717',
    name: 'K C SHARATH .',
    email: 'kcsharth@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-021',
    registerNumber: '26018791',
    name: 'KAPIL VIKNESH K R',
    email: 'kapilvikneshkr@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-022',
    registerNumber: '26002514',
    name: 'Kaviya K',
    email: 'kaviyak1208@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-023',
    registerNumber: '26018917',
    name: 'Kirutika B',
    email: 'kirutika21@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-024',
    registerNumber: '26010681',
    name: 'Koushika B',
    email: 'koushi9952668140@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-025',
    registerNumber: '26013063',
    name: 'MRITYUNJAY I',
    email: 'mrityunjayyiyappan31@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-026',
    registerNumber: '26017966',
    name: 'Mohamed Faheem. A',
    email: 'mohamedfaheem0828@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-027',
    registerNumber: '26010526',
    name: 'Mohamed Sameer B',
    email: 'sox.sameer@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-028',
    registerNumber: '26004544',
    name: 'Mufeedha shahul hamid',
    email: 'majithabanu1987@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-029',
    registerNumber: '26010411',
    name: 'NIKITHA R K',
    email: 'n00187863@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-030',
    registerNumber: '26006042',
    name: 'NIVETHA P',
    email: 'nivenive205@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-031',
    registerNumber: '26016907',
    name: 'Nandhini S',
    email: 'nandhinikamatchi1110@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-032',
    registerNumber: '26010348',
    name: 'PAVITHRAN G',
    email: 'gopalakrishnanpavithran@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-033',
    registerNumber: '26007102',
    name: 'PRAHARSETA S D',
    email: 'praharsetasivakumar@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-034',
    registerNumber: '26017579',
    name: 'RUFUS VIVIAN.G',
    email: 'rufusvivian1209@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-035',
    registerNumber: '26018017',
    name: 'Rakshana Priya P',
    email: 'anbu6490@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-036',
    registerNumber: '26019401',
    name: 'SABAREESH S',
    email: 'sabareeshselvakumar4@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-037',
    registerNumber: '26018662',
    name: 'SRI HARIVARSHAN B',
    email: 'sriharivarshan03@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-038',
    registerNumber: '26015785',
    name: 'SUGAVARMAN K P',
    email: 'pugazhprema@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-039',
    registerNumber: '26018710',
    name: 'SUGUMARAN S',
    email: 'sutharsugu04@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-040',
    registerNumber: '26018806',
    name: 'Sai Ganesh.R.C',
    email: 'saiganeshrc@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-041',
    registerNumber: '26002394',
    name: 'Sana Zulfia S',
    email: 'sanazulfia000@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-042',
    registerNumber: '26010447',
    name: 'Sivasubramaniyam S R',
    email: 'sivasubramaniyam3244@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-043',
    registerNumber: '26000807',
    name: 'TEJASWINI T',
    email: 'tmaniraajan85@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-044',
    registerNumber: '26017668',
    name: 'Thanmaya K',
    email: 'devik3060@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-045',
    registerNumber: '26007899',
    name: 'Thanushree.S',
    email: 'thanushree0424@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-046',
    registerNumber: '26002631',
    name: 'Thoshini S',
    email: 'thoshinichini@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-047',
    registerNumber: '26019044',
    name: 'VASANTH V',
    email: 'manivasanth031@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-048',
    registerNumber: '26018667',
    name: 'VIKRANT G',
    email: 'umaganesh0915@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-049',
    registerNumber: '26007333',
    name: 'Vishal Uppara',
    email: 'vishal.u338@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  },
  {
    id: 'STU-C3-050',
    registerNumber: '26018879',
    name: 'Yogesh V S',
    email: 'yogesh09092008@gmail.com',
    classId: 'C3-091',
    pinHash: PIN_1234_HASH,
    salt: DEFAULT_SALT,
    mustChangePin: false,
    isActive: true,
    createdAt: '2024-08-01T09:00:00Z',
    updatedAt: '2024-08-01T09:00:00Z'
  }
];
